import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-540497d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = { class: "top-right" }
const _hoisted_3 = { class: "user-info" }
const _hoisted_4 = { class: "user-name" }

import { ref, computed } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  DownOutlined,
  FileTextOutlined,
  KeyOutlined,
  LogoutOutlined,
} from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserHeadTop',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();

const user_conf = ref(JSON.parse(localStorage.getItem('user_conf') || '{}'));

// 初始化：优先从 localStorage 读取折叠状态，PC 端默认展开
const savedCollapse = localStorage.getItem('isCollapse');
if (savedCollapse !== null) {
  store.commit('setIsCollapse', parseInt(savedCollapse));
} else {
  store.commit('setIsCollapse', 1); // PC 端默认展开
}

const isCollapsed = computed(() => store.getters.isCollapse == 0 || store.getters.isCollapse == -1);

const displayName = computed(() => {
  if (user_conf.value.username) return user_conf.value.username;
  if (user_conf.value.user_email) return user_conf.value.user_email;
  return '未登录';
});

// 路由标题映射
const titleMap: Record<string, string> = {
  '/console': '控制台',
  '/userLog': '用户日志',
  '/dockKey': '接口密钥',
  '/withdrawal': '提现记录',
  '/agentEmpower': '代理中心',
  '/userManage': '用户管理',
  '/withdrawalManage': '提现管理',
  '/includesList': '软件列表',
  '/develop': '开发总览',
  '/productManage': '产品管理',
  '/VersionLog': '版本管理',
  '/NoticeManage': '公告管理',
  '/DataManage': '数据管理',
  '/CarmineList': '卡密列表',
  '/CarmineUse': '使用卡密',
  '/freeBenefits': '免费授权',
  '/query': '授权查询',
};

const breadcrumbTitle = computed(() => titleMap[route.path] || '页面');

const toggleCollapse = () => {
  const newVal = isCollapsed.value ? 1 : 0;
  store.commit('setIsCollapse', newVal);
  localStorage.setItem('isCollapse', String(newVal));
};

const navigateTo = (path: string) => {
  router.push(path);
};

const outLogin = () => {
  Modal.confirm({
    title: '确认退出',
    content: '您确定要退出登录吗？',
    okText: '确认',
    cancelText: '取消',
    okButtonProps: { danger: false },
    onOk: () => {
      localStorage.removeItem('token');
      localStorage.removeItem('user_conf');
      message.success('退出登录成功');
      setTimeout(() => { location.reload(); }, 1000);
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "trigger-btn",
      onClick: toggleCollapse
    }, [
      (!isCollapsed.value)
        ? (_openBlock(), _createBlock(_unref(MenuFoldOutlined), { key: 0 }))
        : (_openBlock(), _createBlock(_unref(MenuUnfoldOutlined), { key: 1 }))
    ]),
    _createVNode(_component_a_breadcrumb, { class: "top-breadcrumb" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb_item, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(breadcrumbTitle.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
        overlay: _withCtx(() => [
          _createVNode(_component_a_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, {
                key: "profile",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateTo('/')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UserOutlined)),
                  _createTextVNode(" 个人资料 ")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, {
                key: "log",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateTo('/userLog')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FileTextOutlined)),
                  _createTextVNode(" 用户日志 ")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, {
                key: "key",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateTo('/dockKey')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(KeyOutlined)),
                  _createTextVNode(" 对接密钥 ")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_divider),
              _createVNode(_component_a_menu_item, {
                key: "logout",
                onClick: outLogin
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(LogoutOutlined)),
                  _createTextVNode(" 退出登录 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_avatar, {
              size: 32,
              style: {"background-color":"#1677ff"}
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(UserOutlined))
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_4, _toDisplayString(displayName.value), 1),
            _createVNode(_unref(DownOutlined))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})